import { render, staticRenderFns } from "./ZoomIntegration.vue?vue&type=template&id=24629682&scoped=true&"
import script from "./ZoomIntegration.vue?vue&type=script&lang=js&"
export * from "./ZoomIntegration.vue?vue&type=script&lang=js&"
import style0 from "./ZoomIntegration.vue?vue&type=style&index=0&id=24629682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24629682",
  null
  
)

export default component.exports